import type { JSX } from 'react';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
})) as typeof TableRow;

interface Row {
  readonly automaticValue: string | number | JSX.Element;
  readonly differenceValue: string | number | JSX.Element;
  readonly id: string;
  readonly label: string;
  readonly manualValue: string | number | JSX.Element;
}

interface Props {
  readonly ariaLabel: string;
  readonly automaticColumnLabel: string;
  readonly differenceColumnLabel: string;
  readonly manualColumnLabel: string;
  readonly rows: readonly Readonly<Row>[];
}

export const TotalMatrixTable = ({
  ariaLabel,
  automaticColumnLabel,
  differenceColumnLabel,
  manualColumnLabel,
  rows,
}: Readonly<Props>) => (
  <TableContainer component={Paper}>
    <MuiTable aria-label={ariaLabel} size="small">
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell align="right">{manualColumnLabel}</TableCell>
          <TableCell align="right">{automaticColumnLabel}</TableCell>
          <TableCell align="right">{differenceColumnLabel}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(
          ({ id, label, manualValue, automaticValue, differenceValue }) => (
            <StyledTableRow key={id}>
              <TableCell component="th" scope="row">
                {label}
              </TableCell>
              <TableCell align="right">{manualValue}</TableCell>
              <TableCell align="right">{automaticValue}</TableCell>
              <TableCell align="right">{differenceValue}</TableCell>
            </StyledTableRow>
          ),
        )}
      </TableBody>
    </MuiTable>
  </TableContainer>
);
